import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import translationEN from "./Components/Translation/en.json";
import translationAR from "./Components/Translation/ar.json";
import './local';


const win: any = window;
 let lang = document.documentElement.lang;
let lng: string | undefined = lang == null ? "en" : win["lang"];


const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  }
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: lang,
    lng,
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    // backend: {
    //   loadPath: window.location.href.includes("localhost") ? "/translations/{{lng}}.json" : "/.complaints-portal4/react-app/build/translations/{{lng}}.json" ,
    //   allowMultiLoading: true,
    // },
    react: {
      useSuspense: true,
    }
  });

export default i18n;


